import { render, staticRenderFns } from "./FileServer.vue?vue&type=template&id=6984837c&scoped=true"
import script from "./FileServer.vue?vue&type=script&lang=js"
export * from "./FileServer.vue?vue&type=script&lang=js"
import style0 from "./FileServer.vue?vue&type=style&index=0&id=6984837c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6984837c",
  null
  
)

export default component.exports